import { postInviteApi } from '../../invite';
import { CreateInitialParamsData } from './createInitialParams';

type SendSelfSurveyInviteData = CreateInitialParamsData & {
  locale: string;
  jobKey: string;
  identifier: string;
  shouldSendEmail?: boolean;
  shouldSendSms: boolean;
};

export const sendSelfSurveyInvite = async ({ data }: { data: SendSelfSurveyInviteData }) => {
  const { shouldSendEmail, shouldSendSms, insured, locale, company, jobKey, identifier } = data;

  const inviteData = {
    ...insured,
    identifier,
    shouldSendSms,
    shouldSendEmail,
    jobKey,
    companyKey: company.key,
    locale,
  };

  await postInviteApi({ data: inviteData });
};
